<template>
  <div
    class="upload-images-wrapper"
    v-loading="uploading"
    element-loading-text="正在上传"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.2)"
  >
    <div class="head">
      <div style="display:flex;align-items:center;margin-top:0.5%">
        <i style="font-size:1.5rem;margin-right:10px;" class="iconfont icon-xiangji"></i>
        <span id="fontF">影像采集</span>
      </div>
      <div class="btn-wrap">
        <div class="radio-wrap">
          <el-radio-group v-model="commonData.imageStatus" size="mini">
            <el-radio-button label="治疗前"></el-radio-button>
            <el-radio-button label="治疗即刻"></el-radio-button>
            <el-radio-button label="无"></el-radio-button>
          </el-radio-group>
        </div>
        <button
          class="btn"
          style="margin-right: 10px;font-size: 14px;"
          @click="remoteAccessImages('hairdressing', 'hairdressing')"
        >远程同步</button>
        <button class="btn" style="margin-right: 10px;font-size: 14px;" @click="takeAPhone">拍摄</button>
        <button class="btn" @click="handleLocalUploadImage" style="font-size: 14px;">本地上传</button>
        <input
          style="display: none"
          ref="uploadInput"
          type="file"
          name="file"
          multiple="multiple"
          class="upload_input"
          @change="localUploadImage"
          accept="image/jpeg, image/png, image/bmp"
        />
      </div>
    </div>
    <div class="content">
      <div class="image-item" v-for="(item, index) in imageList" :key="item.upload_mark">
        <div
          v-loading="item.showLoadingIcon"
          element-loading-text="正在上传"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.6)"
          style="user-select: none"
        >
          <div class="image-box" :class="{active: item.isActive}" @click="selectImageItem(item)">
            <div class="image">
              <!-- <BreviaryKonva :imgAttrs='imgAttrs'></BreviaryKonva> -->
              <div
                class="mapShade"
                :class="setClass(item)"
                :style="{'height':imgAttrs.heightScale+'px','width':imgAttrs.widthScale+'px','top':imgAttrs.marginTop,'left':imgAttrs.marginLeft}"
              ></div>
              <div
                class="noClick"
                :style="{'height':imgAttrs.heightScale+'px','width':imgAttrs.widthScale+'px','top':imgAttrs.marginTop,'left':imgAttrs.marginLeft}"
              ></div>
              <img
                :src="item.path | handleImagePath"
                alt
                draggable="false"
                @load="imgOnload"
              />
            </div>
            <div class="image-title">
              <span class="status">{{item.status}}</span>
              <span class="time">{{item.created_time | formatTime}} {{item.upload_mark}}</span>
            </div>
            <div class="afloat-menu">
              <div
                class="menu-btn"
                @click.stop="LookBigPhoto({
                imgPath: item.path,
                imgItem: item,
                id: commonData.patientId,
                type: 'hairdressing'
              })"
              >
                <div class="screen-icon iconfont">&#xe6e0;</div>
              </div>
              <div class="menu-btn" @click.stop="deleteImage(item)">
                <img class="delete-icon" src="../assets/delete.png" alt />
              </div>
              <!-- <div class="menu-btn" @click.stop="getSign(item)">
                标记点
              </div>-->
              <div class="menu-btn" v-if="false">
                <img class="love-icon" src="../assets/love.png" alt v-show />
                <img class="love-icon" src="../assets/love_fill.png" alt v-show />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Path from 'path';
import remoteAccessImagesMethod from "../utils/remoteAccessImages.js";
import Jimp from "jimp";
import _ from "lodash";
import gql from "graphql-tag";
import api from "../api";
import moment from "moment";
import { konvaDraw } from "../utils/konvaDraw.js";

export default {
  inject: {
    commonData: ["commonData"],
    selectedImage: ["selectedImage"],
    unSelectedImage: ["unSelectedImage"]
  },
  data() {
    return {
      cosmetology_imagesThumbnails: api.cosmetology_imagesThumbnails,
      imageList: [
        /*{
            id: 1,
            path: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=2621008866,1401000493&fm=26&gp=0.jpg',
            time: '190821-12:20:23',
            isActive: false,
          },*/
      ],
      selectedImageData: null,
      uploading: false,
      imgAttrs: {
        width: 0,
        height: 0,
        scale: 0,
        widthScale: 0,
        heightScale: 0,
        // 默认宽度比高度大
        largeWidth: true,
        margeLeft: 0,
        margeTop: 0
      },
      info: {
        id: "",
        tplType: "hairdressing"
      },
      className: "",
      // 删除图片的ID
      deleteImageId: -1,
    };
  },

  mixins: [remoteAccessImagesMethod, konvaDraw],
  computed: {
    isFreshDraw() {
      if (this.commonData) {
        return this.commonData.showLargeImage;
      } else {
        return false;
      }
    }
  },
  watch: {
    async isFreshDraw(val) {
      if (!val) {
        if (this.commonData) {
          await this.loadImagesSign();
        }
      }
    }
  },
  methods: {
    // 设置图片加载完后的尺寸
    imgOnload(e) {
      // console.log(this.$refs.mapShade)
      // this.$refs.mapShade.style.height =  400+'px';
      // 287 * 290
      const tag = e.target;
      this.imgAttrs.width = e.target.width;
      this.imgAttrs.height = e.target.height;
      if (tag.width / tag.height >= 287 / 290) {
        const height = tag.height;
        const width = tag.width;
        const countWidth = width / (height / 290);
        e.srcElement.style.height = "290px";
        e.srcElement.style.width = countWidth + "px";
        this.imgAttrs.heightScale = 290;
        this.imgAttrs.widthScale = countWidth;
        const s = (countWidth - 287) / 2;
        e.srcElement.style.marginLeft = "-" + s + "px";
        this.imgAttrs.margeTop = 0;
        this.imgAttrs.marginLeft = "-" + s + "px";
        // this.$refs.mapShade.width = countWidth + 'px';
        // this.$refs.mapShade.height = '290px';
      } else {
        const height = tag.height;
        const width = tag.width;
        const countHeight = height / (width / 287);
        e.srcElement.style.width = "287px";
        e.srcElement.style.height = countHeight + "px";
        const s = (countHeight - 290) / 2;
        this.imgAttrs.heightScale = countHeight;
        this.imgAttrs.widthScale = 287;
        this.imgAttrs.margeLeft = 0;
        this.imgAttrs.margeTop = "-" + s + "px";
        e.srcElement.style.marginLeft = 0;
        e.srcElement.style.marginTop = "-" + s + "px";
        // this.$refs.mapShade.width = '287px';
        // this.$refs.mapShade.height = countHeight;
      }
    },
    // 触发上传图片
    handleLocalUploadImage() {
      this.$refs.uploadInput.dispatchEvent(new MouseEvent("click"));
    },
    async selectImg(e) {
      // 如果没有选中文件就return
      if (!e.target.files.length) {
        return;
      }
      const imgObjArr = [];
      const thumbnailIimages = [];
      
      for (const item of e.target.files) {
        // console.log("In commonUploadImages, selectImg, file:", item);
        let reader = new FileReader();
        const imgObj = {};
        await new Promise((resolve, reject) => {
          let ext = item.name.match(/jpg$|JPG$|jpeg$|JPEG$|png$|PNG|bmp$|BMP$|pjpeg$|jfif$|pjp$|dib$/)[0];
          // console.log("ext:", ext);
          reader.readAsDataURL(item);
          reader.onload = async event => {
            if (ext === "bmp" || ext === "dib"|| ext === 'BMP') {
              let b6 = await this.dealBmpImage(event.target.result);
              //console.log(event.target.result);
              imgObj.base64 = b6.replace(/^data:image\/(jpeg|png);base64,/, "");
              imgObj.ext = "jpg";
              imgObj.status = this.commonData.imageStatus === "无" ? "" : this.commonData.imageStatus;
              imgObj.upload_mark = new Date().valueOf() + '_' + Math.floor(Math.random() * 1000000);
              imgObjArr.push(imgObj);
              //this.compressImg(imgObj.base64, (a, base64) => {
              this.compressImg(b6, (a, base64) => {
                thumbnailIimages.push({base64: base64.replace(/^data:image\/(jpeg|png);base64,/, "")})
                resolve();
              })
            } else {
              if (ext === 'pjpeg' || ext === 'jfif' || ext === 'pjp' || ext === 'jpeg'||  ext === 'jpe'|| ext === 'JPG'|| ext === 'JPEG') {
                ext = 'jpg';
              }
              if (ext === 'PNG') {
                ext = 'png';
              }

              imgObj.base64 = event.target.result.replace(/^data:image\/(jpeg|png);base64,/,"");
              imgObj.ext = ext;
              imgObj.status = this.commonData.imageStatus === "无" ? "" : this.commonData.imageStatus;
              imgObj.upload_mark = new Date().valueOf() + '_' + Math.floor(Math.random() * 1000);
              imgObjArr.push(imgObj);
              this.compressImg(event.target.result, (a, base64) => {
                thumbnailIimages.push({base64: base64.replace(/^data:image\/(jpeg|png);base64,/, "")})                
                resolve();
              })
            }
            // resolve();
          };
        });

      }

      return {
          imgObjArr,
          thumbnailIimages
      }
    },

    async compressImg (base64str, callback) {
        // 处理缩放，转换格式
        // new 一个图片，用canvas来压缩
        let img = new Image();
        img.src = base64str;
        let base64 = '';
        await new Promise((resolve, reject) => {
          img.onload = function () {
            const canvas = document.createElement('canvas')
            const ctx = canvas.getContext('2d');
            let iScale = Math.floor(this.width / 200);
            canvas.setAttribute('width', 200)
            canvas.setAttribute('height', Math.floor(this.width/iScale));
            ctx.clearRect(0, 0, canvas.width, canvas.height)
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
            // 转成base64 文件
            base64 = canvas.toDataURL('image/jpeg')
            // 根据自己需求填写大小图片大小
           while (base64.length > 1024 * 1024 * 6) {
              scale -= 0.01
              base64 = canvas.toDataURL('image/jpeg', iScale)
            }
            const arr = base64.split(',')
            const mime = arr[0].match(/:(.*?);/)[1]
            const bytes = atob(arr[1])
            const bytesLength = bytes.length
            const u8arr = new Uint8Array(bytesLength)
            for (let i = 0; i < bytes.length; i++) {
              u8arr[i] = bytes.charCodeAt(i)
            }
            const blob = new Blob([u8arr], { type: mime })
            // 回调函数 根据需求返回二进制数据或者base64数据，我的项目都给返回了
            callback(blob, base64);
            resolve();
          }
        })
      },


    async dealBmpImage(filePath) {
      const image = await Jimp.read(filePath);
      // image.quality(95);
      const base64 = await image.getBase64Async(Jimp.MIME_JPEG);
      return base64;
    },
    async uploadImage(imgObjArr, thumbnailIimagesArr) {
      const imagesArr = _.chunk(imgObjArr, 1);
      const thumbnailIimages = _.chunk(thumbnailIimagesArr, 1);
      let count = 0;
      for (const images of imagesArr) {
        try {
          const res = await this.$apollo.mutate({
            mutation: gql`
              mutation(
                $patient_id: Int!
                $treat_no: String!
                $images: [cosmetologyImageInput!]!
                $thumbnail_images: [ThumbnailImageInput!]!
                $last_img_time: String
                $agent_name: String
              ) {
                addCosmetologyImagesFaster(
                  patient_id: $patient_id
                  treat_no: $treat_no
                  images: $images
                  thumbnail_images: $thumbnail_images
                  last_img_time: $last_img_time
                  agent_name: $agent_name
                )
              }
            `,
            variables: {
              patient_id: this.commonData.patientId,
              treat_no: this.commonData.treat_no,
              images,
              thumbnail_images: thumbnailIimages[count]
            }
          });
          count++;
          if (count === imagesArr.length) {
            return true;
          }
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
          return;
        }
      }
    },
    // 上传完成之前显示缩略图
    showThumbnailImage(imgObjArr) {
      const thumbnailImgArr = imgObjArr.map((item) => ({
        path: 'data:image/jpeg;base64,' + item.base64,
        status: item.status,
        showLoadingIcon: true,
        upload_mark: item.upload_mark,
      }));
      // console.log("# In showThumbnailImage, before concate, imageList.length:", this.imageList.length);
      // console.log("imageList:", this.imageList);
      // console.log("imgObjArr:", imgObjArr);
      // let thumbnailImgArr = [];
      // for(let i=0;i<imgObjArr.length;i++) {
      //   let item = imgObjArr[i];
      //   console.log("item:", item);
      //   thumbnailImgArr.push({
      //     path: 'data:image/jpeg;base64,' + item.base64,
      //     status: item.status,
      //     showLoadingIcon: true,
      //     upload_mark: item.upload_mark,
      //   })
      // }
      this.imageList = [...this.imageList, ...thumbnailImgArr];
    },

    // 本地上传图片获取到图片
    async localUploadImage(event) {
      let e = window.event || event;
      if (this.commonData.patientId === -1) {
        this.$message.error("请添加患者信息");
        e.target.value = "";
        return;
      }
      if (this.commonData.relevantInfoId === -1) {
        this.$message.error("请添加相关信息");
        e.target.value = "";
        return;
      }
      this.uploading = true;
      let { imgObjArr, thumbnailIimages } = await this.selectImg(e);
      // console.log("In commonUploadImages, localUploadImage,imgObjArr:",imgObjArr);
      // console.log("In commonUploadImages, localUploadImage,thumbnailIimages:",thumbnailIimages);
      // 先显示缩略图
      this.showThumbnailImage(imgObjArr);
      this.uploading = false;
      // 上传
      if (imgObjArr) {
        // console.log("In commonUploadImages, localUploadImage,begin uploadImage,this.imageList:",this.imageList);
        const imageIdList = await this.uploadImage(imgObjArr, thumbnailIimages);
        // console.log("In commonUploadImages, localUploadImage, after uploadImage, return imageIdList:", imageIdList);
        if (imageIdList) {
          this.$message({
            message: "上传图片成功",
            type: "success"
          });
          this.imageList.forEach(item => {
            // console.log("In commonUploadImages, localUploadImage, after uploadImage, imageList item:",item);
            item.showLoadingIcon = false;
          });
        }
      }
      // 清除value值
      e.target.value = "";
    },
    // 拍照
    takeAPhone() {
      if (this.commonData.patientId === -1) {
        this.$message.error("请先添加患者信息！");
        return;
      }
      if (this.commonData.relevantInfoId === -1) {
        this.$message.error("请先添加相关信息！");
        return;
      }
      this.$emit("takeAPhone");
    },
    // 选择图片
    selectImageItem(item) {
      /*if (this.selectedImageData && this.selectedImageData.id === item.id) {
        item.isActive = !item.isActive;
        item.isActive ? this.selectedImage(item) : this.unSelectedImage();
      } else {
        if (this.selectedImageData) {
          this.selectedImageData.isActive = false;
        }
        item.isActive = true;
        this.selectedImageData = item;
        this.selectedImage(item);
      }*/
    },
    // 显示图片
    async loadImages() {
      try {
        const res = await this.$apollo.query({
          query: gql`
            query($patient_id: Int!, $treat_no: String!) {
              getCosmetologyReleInfo(
                patient_id: $patient_id
                treat_no: $treat_no
              ) {
                id
                image_cosmetology {
                  id
                  patient_id
                  treat_no
                  path
                  created_time
                  status
                  annotation
                  upload_mark
                }
              }
            }
          `,
          fetchPolicy: "no-cache",
          variables: {
            patient_id: this.commonData.patientId,
            treat_no: this.commonData.treat_no
          }
        });
        const dataArr = res.data.getCosmetologyReleInfo.image_cosmetology;
        // console.log("# In loadImages(),getCosmetologyReleInfo, res:",dataArr);
        // console.log("# In loadImages(),before handle imgs, imageList:",this.imageList);
        for (const item of dataArr) {
          item.isActive = false;
          const findIndex = this.imageList.findIndex((item1) => item1.upload_mark === item.upload_mark);
          if (this.imageList[findIndex]) {
            if (!this.imageList[findIndex].id) {
              this.imageList.splice(findIndex, 1, item);
            }
          } else {
            this.imageList.push(item);
          }
        }
        // console.log("# In loadImages(), after handle imgs, imageList:",this.imageList);
        const findIndex = this.imageList.findIndex((item1) => item1.id === this.deleteImageId);
        // console.log("findIndex for deleteImageId:",this.deleteImageId, findIndex);
        if (findIndex > -1) {
          this.imageList.splice(findIndex, 1);
        }
        if (this.selectedImageData) {
          for (const item of dataArr) {
            if (item.id === this.selectedImageData.id) {
              item.isActive = true;
              this.selectedImageData = item;
              this.selectedImage(item);
            }
          }
        }
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    },
    async loadImagesSign() {
      try {
        const res = await this.$apollo.query({
          query: gql`
            query($patient_id: Int!, $treat_no: String!) {
              getCosmetologyReleInfo(
                patient_id: $patient_id
                treat_no: $treat_no
              ) {
                id
                image_cosmetology {
                  id
                  annotation
                }
              }
            }
          `,
          fetchPolicy: "no-cache",
          variables: {
            patient_id: this.commonData.patientId,
            treat_no: this.commonData.treat_no
          }
        });
        const dataArr = res.data.getCosmetologyReleInfo.image_cosmetology;
        for (const item of dataArr) {
          if(item.annotation) {
            await this.getSign(item)
          }
        }
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    },
    // 点击对比图片
    LookBigPhoto(data) {
      this.$emit("lookBigPhoto", data);
    },
    // 删除图片
    async deleteImage(item) {
      this.$confirm("确定要删除该图片吗？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.deleteImageId = item.id;
          try {
            const res = await this.$apollo.mutate({
              mutation: gql`
                mutation($treat_no: String!, $ids: [Int!]!) {
                  removeCosmetologyImages(treat_no: $treat_no, ids: $ids)
                }
              `,
              variables: {
                treat_no: this.commonData.treat_no,
                ids: [item.id]
              }
            });
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          } catch (error) {
            this.$message.error(error.message.split(":")[1]);
          }
        })
        .catch(() => {
          // console.log('取消删除');
        });
    },
    async getSign(item) {
      // console.log(item)
      // console.log('我获取了标点信息')
      this.info.id = item.id;
      this.toggleStatusSign = false; // 保持切换到sign的状态
      await this.setKonva(
        ".mapShade" + item.id.toString(),
        this.imgAttrs.widthScale,
        this.imgAttrs.heightScale
      );
    },
    restart() {
      // 清理插件報錯
    },
    moveHandler() {
      // 清理插件報錯
    },
    setClass(item) {
      let newClass;
      if (item) {
        if (item.id) {
          newClass = "mapShade" + item.id.toString();
        }
      } else {
        newClass = '';
      }
      return newClass;
    }
  },

  mounted() {
    // 上传图片后接到的刷新图片推送事件
    this.$root.$on("refresh-cosmetology-images", async () => {
      if (this.commonData.patientId > -1 && this.commonData.treat_no) {
        await this.loadImages();
        await this.loadImagesSign();
      }
    });
    // this.$root.$on("addSign-showImage", data => {
    //   this.LookBigPhoto(data);
    // });
    // 长连接
    this.$root.$on("connect2server", () => {
      if (sessionStorage.getItem("username")) {
        if (window.eventSrc) {
          window.eventSrc.close();
        }
        window.eventSrc = new EventSource(api.event, {
          withCredentials: true
        });
        window.eventSrc.onmessage = async event => {
          this.$root.$emit(event.data);
        };
        window.eventSrc.onopen = () => {
          window.lastHeartBeat = new Date();
        };
        window.eventSrc.addEventListener("hb", event => {
          window.lastHeartBeat = new Date();
        });
      }
    });
    // this.$refs.mapShade.width = '287px';
    // this.$refs.mapShade.height = countHeight;\
    this.setClass();
    // 如果是点击编辑跳转过来
    if (this.$store.state.modifyCosmetologyData.status) {
      this.$store.commit('addModifyCosmetologyStatusCount');
      const timer = setInterval(async () => {
        if (this.commonData.patientId > -1 && this.commonData.treat_no) {
          clearInterval(timer);
          await this.loadImages();
          await this.loadImagesSign();

        }
      }, 200);
    }
  },

  beforeDestroy() {
    this.$root.$off("refresh-cosmetology-images");
    this.$root.$off("connect2server");
    // this.$root.$off("addSign-showImage");
  },

  filters: {
    formatTime(val) {
      return moment(val).format("YYYY-MM-DD HH:mm:ss");
    },
    handleImagePath(val) {
      const Reg = /^data:image\/(jpeg|png);base64,/;
      return Reg.test(val) ? val : api.cosmetology_imagesThumbnails + val
    }
  }
};
</script>

<style>
.upload-images-wrapper .el-radio-button__inner {
  width: 80px;
  font-size: 14px;
}
</style>
<style lang="less" scoped>
.upload-images-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-bottom: 4px;
  box-sizing: border-box;
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #48a3c2;
    font-size: 16px;
    border-bottom: 1px solid #48a3c2;
    background-color: #fff;
    padding: 5px;
    padding-bottom: 10px;
    overflow: hidden;
    height: 30px;
    text-align: left;
    .btn-wrap {
      display: flex;
      .radio-wrap {
        display: flex;
        align-items: center;
        margin-right: 10px;
        font-size: 14px;
      }
    }
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    box-shadow: 0 2px 3px #909090;
    background-color: #eff2f7;
    padding: 15px 10px;
    overflow-y: auto;
    .image-item {
      width: 293px;
      height: 320px;
      padding: 5px 3px;
      .image-box {
        position: relative;
        width: 100%;
        height: 100%;
        padding: 3px;
        box-sizing: border-box;
        box-shadow: 1px 1px 3px 1px #c0c0c0;
        background-color: #ffffff;
        .image {
          height: 290px;
          overflow: hidden;
          position: relative;
          .mapShade {
            position: absolute;
            width: 20px;
            height: 20px;
            top: 0;
            left: 0;
          }
          .noClick {
            position: absolute;
            user-select: none;
            opacity: 0;
          }
        }
        .image-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 24px;
          .status {
            padding-left: 10px;
            font-weight: bold;
            font-size: 15px;
          }
          .time {
            padding-right: 10px;
            font-weight: bold;
            font-size: 15px;
          }
        }
        .afloat-menu {
          display: none;
          position: absolute;
          left: 0;
          top: 0;
          margin-top: 5px;
          margin-left: 5px;
          .menu-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50px;
            height: 40px;
            background-color: #ebebeb;
            border-radius: 5px;
            background-color: rgba(240, 240, 240, 0.7);
            cursor: pointer;
            user-select: none;
            .screen-icon {
              color: #1296db;
              font-size: 26px;
            }
            .delete-icon {
              width: 30px;
              height: 30px;
            }
            .love-icon {
              width: 32px;
              height: 32px;
            }
          }
          .menu-btn + .menu-btn {
            margin-left: 2px;
          }
        }
      }
      .image-box:hover .afloat-menu {
        display: flex;
      }
      .image-box.active {
        background-color: rgb(97, 162, 191);
      }
      .image-box.active .image-title {
        color: #ffffff;
      }
    }
  }
}
</style>
